import { isNil, map, omitBy } from 'lodash';

const model = (data: any) => {

    let items: any[] = [];
    data.map(item => {
        items.push({
            inventoryID: item.productData.inventoryID,
            variants: [item.selectedVariant.variantCode],
        })
    })
    return items;
}

export default model;
